export default function Hero() {
  return (
    <div className="relative w-full flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/809f14a402446828bba6d79e902cee60.jpeg')`,
          backgroundSize: 'contain',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          transform: 'scaleY(1.265)',
        }}
      >
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 py-24" style={{ minHeight: '720px' }}>
        <div className="max-w-3xl mx-auto text-center">
          <div className="mb-10">
            <h1 className="mb-8 flex justify-center">
              <div className="inline-block bg-white/30 p-4 rounded-lg shadow-2xl border-4 border-gray-900">
                <img 
                  src="https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/13208261dd886fe769b42bf1dec41b63.png" 
                  alt="PCS Premier Contracting Services Marine & Dock Construction"
                  className="w-auto max-w-sm h-auto"
                />
              </div>
            </h1>
            <div className="space-y-3 text-xl md:text-2xl">
              <p className="font-semibold text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.8), 1px -1px 2px rgba(0,0,0,0.8), -1px 1px 2px rgba(0,0,0,0.8)' }}>- FULL SERVICE DOCK REPLACEMENT &amp; REPAIR</p>
              <p className="font-semibold text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.8), 1px -1px 2px rgba(0,0,0,0.8), -1px 1px 2px rgba(0,0,0,0.8)' }}>- MARINE PLUMBING, MARINE MECHANICAL &amp; MARINE ELECTRICAL</p>
              <p className="font-semibold text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.8), 1px -1px 2px rgba(0,0,0,0.8), -1px 1px 2px rgba(0,0,0,0.8)' }}>- LICENSED &amp; INSURED</p>
              <p className="font-semibold text-yellow-500" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.8), 1px -1px 2px rgba(0,0,0,0.8), -1px 1px 2px rgba(0,0,0,0.8)' }}>- CSLB # 1121944</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 mt-12 justify-center">
            <a 
              href="#contact" 
              className="whitespace-nowrap cursor-pointer bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold px-10 py-5 rounded-lg text-lg transition-all duration-300 transform hover:scale-105 text-center border-2 border-gray-900"
            >
              Get Free Quote
            </a>
            <a
              href="tel:916-884-4818"
              className="inline-flex items-center gap-3 bg-[#172554] hover:bg-[#1e3a8a] text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 cursor-pointer border-2 border-gray-900 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]"
              style={{
                textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.5)'
              }}
            >
              <i className="ri-phone-fill mr-2"></i>
              Sales : 916-224-0308
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </div>
  );
}